package com.klantenstop.web.data.models.domain

sealed class VerificationStatus(
    val title: String,
    val description: String,
    val buttonText: String? = null
) {
    companion object;

    data object Verifying : VerificationStatus(
        "Jouw e-mailadres verifiëren...",
        "Even geduld terwijl we je e-mailadres verifiëren"
    )

    data object Success : VerificationStatus(
        "✓ E-mailadres succesvol geverifieerd!",
        "Je e-mailadres is geverifieerd.\nJe kan dit venster sluiten of op de knop klikken om terug naar de website te gaan.",
        "Ga naar de website",
    )

    data object AlreadyVerified : VerificationStatus(
        "Account is al geverifieerd",
        "Uw account is al geverifieerd. U kunt inloggen op uw account.",
        "Ga naar de website"
    )

    data object Expired : VerificationStatus(
        "Verificatiecode verlopen",
        "De verificatiecode is verlopen. Vraag een nieuwe verificatie-e-mail aan.",
        "Opnieuw verzenden"
    )

    data class Error(val message: String) : VerificationStatus(
        "Verificatie mislukt",
        message
    )

    data object SuccessfullySent : VerificationStatus(
        "Verificatie-e-mail verzonden",
        "Er is een nieuwe verificatie-e-mail verzonden naar jou e-mailadres.\nControleer je inbox om je e-mailadres te verifiëren.",
        null
    )

    data object FailedToSend : VerificationStatus(
        "Verificatie-e-mail niet verzonden",
        "Er is een fout opgetreden bij het verzenden van de verificatie-e-mail. Probeer het later opnieuw.",
        null
    )
}
